export type VerwaltungsartCode = 'MV' | 'WEG' | 'SEV';

export interface VerwaltungsartInfo {
  /** Kurzcode für den Badge */
  code: VerwaltungsartCode;
  /** Ausgeschriebene Bezeichnung (Tooltip/aria) */
  label: string;
}

/**
 * Leitet die Verwaltungsart (MV/WEG/SEV) aus dem gemischten `objekttyp`-Feld ab.
 *
 * Das `objekttyp`-Dropdown mischt Verwaltungsart und Gebäudeart. Mapping:
 * - WEG, Teileigentum            → WEG
 * - SEV, Sondereigentum          → SEV
 * - alles übrige (Mietverwaltung, Mehrfamilienhaus, Einfamilienhaus, Gewerbe, Neubau, …) → MV
 * - leer / null / undefined      → null (kein Badge)
 */
export function verwaltungsartAusObjekttyp(objekttyp: string | null | undefined): VerwaltungsartInfo | null {
  const t = (objekttyp || '').trim().toLowerCase();
  if (!t) return null;
  if (t === 'weg' || t === 'teileigentum') return { code: 'WEG', label: 'WEG-Verwaltung' };
  if (t === 'sev' || t === 'sondereigentum') return { code: 'SEV', label: 'Sondereigentumsverwaltung' };
  return { code: 'MV', label: 'Mietverwaltung' };
}
